<template>
  <div class="drop">
    <modal
      name="errorModal"
      :draggable="true"
      :clickToClose="false"
      :height="225"
      :width="450"
    >
      <v-card style="height: 225px; width: 450px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Error</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle
          >Something went wrong. Please try again. If the error persists, please
          contact support.</v-card-subtitle
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <v-layout
      justify-center
      align-content-center
      align-center
      column
      v-if="!isAgencyUser"
    >
      <v-icon color="green" size="100">mdi-account-supervisor</v-icon>

      <v-card-title style="color: #00558c; font-weight: bold"
        >Lead Management Hierarchy</v-card-title
      >
      <v-card-subtitle>View &amp; Assign Agency Hierarchies</v-card-subtitle>
      <br />

      <form>
        <v-select
          v-model="select"
          :items="sortedItems"
          item-text="ao"
          item-value="id"
          label="Please Select an Agency Owner"
          persistent-hint
          return-object
          single-line
          solo
          :disabled="waitCircle"
          style="width: 400px"
          :menu-props="{ maxHeight: 175 }"
        ></v-select>
        <!-- @input="gotoHierarchy()" -->
        <v-layout align-end align-content-end justify-end>
          <v-btn
            color="green"
            class="menuBtn"
            dark
            @click="$router.push('/')"
            style="margin-right: 10px"
            >Return to Main Menu</v-btn
          >
          <v-btn color="green" dark class="menuBtn" @click="gotoHierarchy()"
            >Submit</v-btn
          >
        </v-layout>
      </form>
      <v-progress-circular
        indeterminate
        color="green"
        v-if="waitCircle"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
    </v-layout>
    <v-layout v-else justify-center align-content-center align-center column>
      <v-icon color="green" size="100">mdi-account-supervisor</v-icon>

      <v-card-title style="color: #00558c; font-weight: bold"
        >Lead Management Hierarchy</v-card-title
      >
      <v-card-subtitle>Please Wait...</v-card-subtitle>
    </v-layout>
  </div>
</template>
<script>
import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "@/graphql/queries";
import utilityMixins from "@/utility-mixins.js";

export default {
  created() {
    if (this.isAgencyUser) {
      this.getAOForUser();
    } else {
      this.getAOs();
    }
  },
  mixins: [utilityMixins],
  computed: {
    sortedItems() {
      return this.sortByName(this.items, "name");
    },
  },
  data() {
    return {
      select: {},
      items: [],
      waitCircle: false,
    };
  },
  methods: {
    async getAOForUser() {
      try {
        let AO_Op = await API.graphql(
          graphqlOperation(queries.getAOByUser, {
            agentNum: this.$store.state.currentUser.agentNum,
            company: this.$store.state.currentCompany,
          })
        ).catch((e) => {
          this.addToErrorLogs("Hierarchy getAOForUser getAOByUser", e);
          this.$modal.show("errorModal");
          return;
        });

        if (AO_Op) {
          let AO = AO_Op.data.getAOByUser;

          if (AO) {
            let name = (
              (
                (AO.LastName ? AO.LastName : "") +
                ", " +
                (AO.FirstName ? AO.FirstName : "")
              ).trim() +
              " " +
              (AO.MiddleName ? AO.MiddleName : "")
            ).trim();

            if (
              AO.LastName.trim() == "Office" &&
              AO.FirstName.trim() == "Home"
            ) {
              name = "Home Office";
            }

            let id = AO.AgentNumPrimary;

            this.$store.commit("setAO", {
              ao: id + " " + name,
              id: id,
              name: name,
            });
            this.$router.push("/office");
          }
        } else {
          this.waitCircle = false;
          this.addToErrorLogs(
            "Hierarchy getAOForUser",
            new Error("AO data not retrieved.")
          );
          this.$modal.show("errorModal");
        }
      } catch (e) {
        this.waitCircle = false;
        this.addToErrorLogs("Hierarchy getAOForUser", e);
        this.$modal.show("errorModal");
      }
    },
    async getAOs() {
      try {
        this.waitCircle = true;

        let AOs = await API.graphql(
          graphqlOperation(queries.getAOs, {
            company: this.$store.state.currentCompany,
          })
        ).catch((e) => {
          this.waitCircle = false;
          this.addToErrorLogs("Hierarchy getAOs", e);
          this.$modal.show("errorModal");
          return;
        });

        let AOsInJSON = JSON.parse(JSON.stringify(AOs));

        this.items = [];
        if (AOsInJSON && AOsInJSON.data && AOsInJSON.data.getAOs.length) {
          for (let AO of AOsInJSON.data.getAOs) {
            let name = (
              (
                (AO.LastName ? AO.LastName : "") +
                ", " +
                (AO.FirstName ? AO.FirstName : "")
              ).trim() +
              " " +
              (AO.MiddleName ? AO.MiddleName : "")
            ).trim();

            if (
              AO.LastName.trim() == "Office" &&
              AO.FirstName.trim() == "Home"
            ) {
              name = "Home Office";
            }

            let id = AO.AgentNumPrimary;

            this.items.push({ ao: id + " " + name, id: id, name: name });
          }
        } else {
          this.waitCircle = false;
          this.addToErrorLogs(
            "Hierarchy getAOs",
            new Error("AO data not retrieved.")
          );
          this.$modal.show("errorModal");
        }
        this.$store.commit("setAOArray", this.items);
        this.waitCircle = false;
      } catch (e) {
        this.waitCircle = false;
        this.addToErrorLogs("Hierarchy getAOs", e);
        this.$modal.show("errorModal");
      }
    },

    gotoHierarchy() {
      this.$store.commit("setAO", this.select);

      // let curAgency = this.agencies.find(a => a.aoId == this.select.id);
      // this.$store.commit("setAgency", curAgency);

      // this.$router.push("/agencyhierarchy");
      this.$router.push("/office");
    },
  },
};
</script>
<style scoped>
.drop {
  margin-top: 125px;
}
.waitCircle {
  z-index: 20;
  position: absolute;
  top: 69%;
  left: 48%;
}
</style>
